export class MockdataSearchProviderConfig {
    constructor() {
        this.isReady = true;
    }
}
